import { Currency } from '../../../../enums';
import { getCurrency } from '../../../../cache';
export const getZeroPrice = (currency) => {
    const zeroPrice = {
        amount: 0,
        currency: getCurrency()
    };
    if (currency in Currency) {
        zeroPrice.currency = currency;
    }
    return zeroPrice;
};
